import { render, staticRenderFns } from "./FooterLoader.vue?vue&type=template&id=561d8e80&"
import script from "./FooterLoader.vue?vue&type=script&lang=js&"
export * from "./FooterLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports